import { Dispatch, FC, SetStateAction, useEffect } from "react";
import { Control, FieldValues } from "react-hook-form";
import ModalIndicator from "../component/ModalIndicator";
import { FilterConfig } from "../../../types/Components/Table/FilterConfig";
import { ModalConfig } from "../../../types/Components/Modal/ModalConfig";
import { Box, Flex, Heading } from "@chakra-ui/react";
import AccordionComponent from "../../../components/atom/Accordion/AccordionComponent";
import SearchAreaTemplate from "../../../components/template/Search/SearchAreaTemplate";
import { IndicatorFormValues } from "../../../types/Indicator/IndicatorDataReport/IndicatorFormValues";

interface RegionSearchTamplateProps {
  dataTable: any[];
  setDataTable: (data: any) => void;
  modalConfig: ModalConfig;
  filterConfig: FilterConfig;
  searchTableName: string;
  setIsSearching: Dispatch<SetStateAction<boolean>>;
  control: Control<FieldValues, any>;
  filterState: any;
  historyTitle: string;
  totalItems: number;
  setFormValues: Dispatch<SetStateAction<IndicatorFormValues>>;
  formValues: IndicatorFormValues;
}

const RegionSearchTamplate: FC<RegionSearchTamplateProps> = ({
  dataTable,
  setDataTable,
  modalConfig,
  filterConfig,
  searchTableName,
  setIsSearching,
  control,
  historyTitle,
  totalItems,
  setFormValues,
  formValues,
}) => {
  useEffect(() => {
    const row = control._formValues?.row;
    if (row) {
      setFormValues({
        frequency: row.frequency || null,
        province: row.province || null,
        county: row.county || null,
        indicator: row.indicator || null,
      });
    }
  }, [control._formValues?.row, setFormValues]);

  return (
    <Flex direction="column" gap="4">
      <Flex direction="row" justifyContent="space-between">
        <Heading fontSize="2xl">{searchTableName}</Heading>
      </Flex>
      <AccordionComponent accordionTitle="Pesquisar e Filtrar">
        <Box border="none">
          <SearchAreaTemplate
            setDataTable={setDataTable}
            dataTable={dataTable}
            searchTitle="Pesquisar pelo indicador"
            filterFunction={filterConfig.filterFunction}
            filters={filterConfig.filters}
            keepActiveFilters={filterConfig.keepActiveFilters}
            selectedFilterItem={filterConfig.selectedFilterItem}
            setSelectedFilterItem={filterConfig.setSelectedFilterItem}
            hasInputSearch={filterConfig.hasInputSearch}
            setIsSearching={setIsSearching}
            totalItems={totalItems}
          >
            {filterConfig.filterChildren}
          </SearchAreaTemplate>
        </Box>
      </AccordionComponent>
      <ModalIndicator
        control={control}
        modalConfig={modalConfig}
        indicatorId={formValues.indicator?.id ?? undefined}
        frequency={formValues.indicator?.frequency ?? null}
        provinceId={filterConfig.filters[1].value}
        countyId={filterConfig.filters[2] ? filterConfig.filters[2].value : ""}
        historyTitle={historyTitle}
      />
    </Flex>
  );
};

export default RegionSearchTamplate;
